export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const MARK_AS_READ_NOTIFICATION = 'MARK_AS_READ_NOTIFICATION'
export const MARK_SOUND_AS_PLAYING = 'MARK_SOUND_AS_PLAYING'
export const RESET_STATE = 'RESET_STATE'
